module.exports = __webpack_public_path__ + "img/piercing.529f9b8c.svg";